import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AppSettings } from '../../sharedcomponents/_common/constants/app.constants';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { ReplaySubject } from 'rxjs/ReplaySubject';

@Injectable()
export class PayagainFailedorderService {
  private failtransbenifcaryDetail = new ReplaySubject<any>();
  private repayMentDetail = new ReplaySubject<any>();
  private repetOrder = new ReplaySubject<any>();
  constructor(private http: Http,
    private utilserv: utilityService) {

     }

  getfailedtransactionlistservice(failedTrans) {
    return this.utilserv.soapPostwithoutAction(this.getfailedtransactionlistenvolpe(failedTrans),
      AppSettings.transactionService);
  }
  getfailedtransactionlistenvolpe(failedTrans) {
    const currencyCodeTO = this.utilserv.getObjectText(failedTrans.CurrencyCodeTo);
    const customerPaymentMethod = this.utilserv.getObjectText(failedTrans.CustomerPaymentMethod);
    const currentStatus = this.utilserv.getObjectText(failedTrans.Current);
    const envelope = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
      <s:Header>
        <a:Action s:mustUnderstand="1">http://tempuri.org/ITransactionService/GetFailedOrder</a:Action>
        <a:MessageID>urn:uuid:7886c919-bb63-4f16-84e9-8b643dcdd2e0</a:MessageID>
        <a:ReplyTo>
          <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
        </a:ReplyTo>
      </s:Header>
      <s:Body>
        <FailedOrderRequest xmlns="http://tempuri.org/">
          <CurrencyCodeTo>${currencyCodeTO}</CurrencyCodeTo>
          <CustomerPaymentMethod>${customerPaymentMethod}</CustomerPaymentMethod>
          <LanguageCode>${sessionStorage.langCode}</LanguageCode>
          <Session xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.OrderProcessing.Contracts.DataContracts.Soap" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
      <d4p1:T1>${sessionStorage.T1}</d4p1:T1>
      <d4p1:T2>${sessionStorage.T2}</d4p1:T2>
          </Session>
          <Status>${currentStatus}</Status>
        </FailedOrderRequest>
      </s:Body>
    </s:Envelope>`;


    //console.log(envelope);
    return envelope;

  }
  setfailtransbenifcaryDetailData(dataValues: any) {
    this.failtransbenifcaryDetail.next(dataValues);
  }

  getfailtransbenifcaryDetailData(): Observable<any> {
    return this.failtransbenifcaryDetail.asObservable();
  }



  // setbeneficiaryforRepeatOrder(dataValues: any) {
  //   this.repetOrder.next(dataValues);
  // }
  // getbeneficiaryforRepeatOrder(): Observable<any> {
  //   return this.repetOrder.asObservable();
  // }


  setrepaytransbenifcaryDetailData(dataValues: any) {
    this.repayMentDetail.next(dataValues);
  }

  getrepaytransbenifcaryDetailData(): Observable<any> {
    return this.repayMentDetail.asObservable();
  }

}



// WEBPACK FOOTER //
// ./src/app/_services/transaction/payagain-failedorder.service.ts